import { TeaserData } from "@app/types/ServerCustomContext";
import { useInView } from "@components/hooks/useInView";
import placeholders from "@pub/placeholders";
import { Card } from "@sphtech/dmg-design-system";
import cx from "classnames";

import styles from "./trendingcarousel.module.css";

type Props = {
  contentBlockItem: TeaserData;
};

const TrendingCarouselCard = ({ contentBlockItem }: Props) => {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: "0px -49%",
  });

  return (
    <div
      ref={ref}
      className={cx(styles.cardContainer, inView && styles.inView)}
    >
      <Card
        {...contentBlockItem}
        variant="card-stacked-overlap-summary-portrait"
        mobileUpVariant="card-stacked-overlap-summary-portrait-mobile-up"
        placeholders={placeholders}
        displayPublishDate={false}
        tags={undefined}
        sections={[]}
      />
    </div>
  );
};

export default TrendingCarouselCard;
